// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Proxima Nova:300,300i,400,400i,500,500i,700,700i);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Titillium+Web:ital,wght@0,200;0,300;0,400;0,600;0,700;0,900;1,200;1,300;1,400;1,600;1,700&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://use.typekit.net/ija5zmr.css);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.titilliumweb_font {
  font-family: "Titillium Web", sans-serif !important;
}

.text-gray4 {
  color: #707070 !important;
}

.text-gray3 {
  color: #E5E5E5 !important;
}

.border-theme {
  border-color: #ced4da !important;
}

.text-theme {
  color: #36A1F5 !important;
}

.text-blue {
  color: #231c86 !important;
}

.theme-info {
  color: #00C2FF !important;
}

.bg-theme {
  background: #36A1F5 !important;
}

.bg-darkblue {
  background: #212B65 !important;
}

.theme-red {
  color: #ff0000 !important;
}

.theme-purple {
  color: #A300FF !important;
}

.theme-darkblue {
  color: #212B64 !important;
}

.border-darkblue {
  border-color: #212B65 !important;
}

/*----------------------------------------------
    Buttons
-----------------------------------------------*/
.btn-white {
  font-weight: 400;
  color: #000000;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: #ffffff;
  border: 1px solid #ffffff;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-white:hover, .btn-white:active, .btn-white:focus, .btn-white:not(:disabled):not(.disabled):active:focus, .btn-white:not(:disabled):not(.disabled).active:focus, .btn-white:not(:disabled):not(.disabled):active {
  color: #000000;
  background: #f1f3f5;
  border: 1px solid #f1f3f5;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-white-outline {
  font-weight: 400;
  color: #707070;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: transparent;
  border: 1px solid #ced4da;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-white-outline:hover, .btn-white-outline:active, .btn-white-outline:focus, .btn-white-outline:not(:disabled):not(.disabled):active:focus, .btn-white-outline:not(:disabled):not(.disabled).active:focus, .btn-white-outline:not(:disabled):not(.disabled):active {
  color: #707070;
  background: #f1f3f5;
  border: 1px solid #ced4da;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-black {
  font-weight: 400;
  color: #ffffff;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: #000000;
  border: 1px solid #000000;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-black:hover, .btn-black:active, .btn-black:focus, .btn-black:not(:disabled):not(.disabled):active:focus, .btn-black:not(:disabled):not(.disabled).active:focus, .btn-black:not(:disabled):not(.disabled):active {
  color: #ffffff;
  background: #212529;
  border: 1px solid #212529;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-green {
  font-weight: 400;
  color: #ffffff;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: #00C596;
  border: 1px solid #00C596;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-green:hover, .btn-green:active, .btn-green:focus, .btn-green:not(:disabled):not(.disabled):active:focus, .btn-green:not(:disabled):not(.disabled).active:focus, .btn-green:not(:disabled):not(.disabled):active {
  color: #ffffff;
  background-color: #00a780;
  border: 1px solid #00a780;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-lightgreen {
  font-weight: 400;
  color: #00C596;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: hsla(166, 100%, 39%, 0.11);
  border: 1px solid #00C596;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-lightgreen:hover, .btn-lightgreen:active, .btn-lightgreen:focus, .btn-lightgreen:not(:disabled):not(.disabled):active:focus, .btn-lightgreen:not(:disabled):not(.disabled).active:focus, .btn-lightgreen:not(:disabled):not(.disabled):active {
  color: #00C596;
  background-color: hsla(166, 100%, 39%, 0.4);
  border: 1px solid #009b77;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-darkblue {
  font-weight: 400;
  color: #ffffff;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background: #202B63;
  border: 1px solid #3A4789;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-darkblue:hover, .btn-darkblue:active, .btn-darkblue:focus, .btn-darkblue:not(:disabled):not(.disabled):active:focus, .btn-darkblue:not(:disabled):not(.disabled).active:focus, .btn-darkblue:not(:disabled):not(.disabled):active {
  color: #ffffff;
  background: #1c2658;
  border: 1px solid #303b74;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-darkblue-outline {
  font-weight: 400;
  color: #202B63;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background: #ffffff;
  border: 1px solid #3A4789;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-darkblue-outline:hover, .btn-darkblue-outline:active, .btn-darkblue-outline:focus, .btn-darkblue-outline:not(:disabled):not(.disabled):active:focus, .btn-darkblue-outline:not(:disabled):not(.disabled).active:focus, .btn-darkblue-outline:not(:disabled):not(.disabled):active {
  color: #ffffff;
  background: #202B63;
  border: 1px solid #3A4789;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-blue {
  font-weight: 400;
  color: #ffffff;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: #077EE6;
  border: 1px solid #077EE6;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-blue:hover, .btn-blue:active, .btn-blue:focus, .btn-blue:not(:disabled):not(.disabled):active:focus, .btn-blue:not(:disabled):not(.disabled).active:focus, .btn-blue:not(:disabled):not(.disabled):active {
  color: #ffffff;
  background-color: #0172d4;
  border: 1px solid #0172d4;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-blue-outline {
  font-weight: 400;
  color: #077EE6;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: #ffffff;
  border: 1px solid #077EE6;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-blue-outline:hover, .btn-blue-outline:active, .btn-blue-outline:focus, .btn-blue-outline:not(:disabled):not(.disabled):active:focus, .btn-blue-outline:not(:disabled):not(.disabled).active:focus, .btn-blue-outline:not(:disabled):not(.disabled):active {
  color: #ffffff;
  background-color: #077EE6;
  border: 1px solid #077EE6;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-lightblue {
  font-weight: 400;
  color: #ffffff;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: #36A1F5;
  border: 1px solid #36A1F5;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-lightblue:hover, .btn-lightblue:active, .btn-lightblue:focus, .btn-lightblue:not(:disabled):not(.disabled):active:focus, .btn-lightblue:not(:disabled):not(.disabled).active:focus, .btn-lightblue:not(:disabled):not(.disabled):active {
  color: #ffffff;
  background-color: #2aa0fa;
  border: 1px solid #2aa0fa;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-lightblue-outline {
  font-weight: 400;
  color: #36A1F5;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: #F2F9FF;
  border: 1px solid #36A1F5;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-lightblue-outline:hover, .btn-lightblue-outline:active, .btn-lightblue-outline:focus, .btn-lightblue-outline:not(:disabled):not(.disabled):active:focus, .btn-lightblue-outline:not(:disabled):not(.disabled).active:focus, .btn-lightblue-outline:not(:disabled):not(.disabled):active {
  color: #ffffff;
  background-color: #36A1F5;
  border: 1px solid #36A1F5;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-lightred {
  font-weight: 400;
  color: #CB3F3F;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: #FFEFEF;
  border: 1px solid #FF004E;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-lightred:hover, .btn-lightred:active, .btn-lightred:focus, .btn-lightred:not(:disabled):not(.disabled):active:focus, .btn-lightred:not(:disabled):not(.disabled).active:focus, .btn-lightred:not(:disabled):not(.disabled):active {
  color: #CB3F3F;
  background-color: #fda3a3;
  border: 1px solid #FF004E;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.btn-lightOrange {
  font-weight: 400;
  color: #feb019;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background-color: #f8efde;
  border: 1px solid #feb019;
  padding: 0.5rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 0.2rem;
  text-transform: uppercase;
  transition: all 0.5s;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}
.btn-lightOrange:hover, .btn-lightOrange:active, .btn-lightOrange:focus, .btn-lightOrange:not(:disabled):not(.disabled):active:focus, .btn-lightOrange:not(:disabled):not(.disabled).active:focus, .btn-lightOrange:not(:disabled):not(.disabled):active {
  color: #feb019;
  background-color: #fce9c5;
  border: 1px solid #feb019;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
}

.result-analysis-nav {
  position: relative;
}
.result-analysis-nav::after {
  content: "";
  height: 100%;
  width: 100%;
  left: 0;
  top: 0;
  position: absolute;
  background: #077EE6;
  opacity: 0.6;
}
.result-analysis-nav .header-top {
  position: relative;
  box-shadow: none;
  z-index: 2;
}
.result-analysis-nav .header-top .navbar-nav {
  align-items: center;
}
.result-analysis-nav .header-top .navbar-nav .nav-link {
  color: #ffffff;
}
.result-analysis-nav .header-top .navbar-nav .profile-img {
  background: rgba(255, 255, 255, 0.1215686275);
  border: 1px solid rgba(255, 255, 255, 0.0901960784);
  border-radius: 21px;
}
.result-analysis-nav .header-top .navbar-nav .profile-img img {
  width: 35px;
  height: 35px;
}
.result-analysis-nav .header-top .navbar-nav .profile-img .text .profile-name {
  font-size: 14px;
  line-height: 6px;
}
.result-analysis-nav .header-top .search .search-bar {
  color: #ffffff;
  background: rgba(255, 255, 255, 0.0901960784);
  box-shadow: none;
}
.result-analysis-nav .header-top .student-notification i {
  font-size: 1.5rem;
}
.result-analysis-nav .header-bottom {
  position: relative;
  z-index: 1;
}
.result-analysis-nav .header-bottom .card {
  background-color: hsla(0, 0%, 100%, 0.46);
  border-radius: 10px;
}
.result-analysis-nav .header-bottom .card img {
  margin-top: -3rem;
  margin-bottom: 10px;
}
.result-analysis-nav .header-bottom .datePicker .calendar {
  color: #ffffff;
  position: absolute;
  left: 15px;
  top: 0;
  font-size: 18px;
  background: rgba(255, 255, 255, 0.4588235294);
  padding: 10px;
  border-radius: 4px;
}
.result-analysis-nav .header-bottom .datePicker .form-control {
  padding-left: 40px;
  background-color: hsla(0, 0%, 100%, 0.46);
  color: #ffffff;
}
.result-analysis-nav .header-bottom .datePicker .form-control::placeholder {
  color: #ffffff;
}
.result-analysis-nav .header-bottom .datePicker .rdtPicker {
  right: 0;
}

.w-35 {
  width: 35% !important;
}

.result-analysis .overall-accureny {
  box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.1607843137);
  border-radius: 0.4rem;
}
.result-analysis .overall-accureny .card-body.content {
  border: 1px solid transparent;
}
.result-analysis .overall-accureny .card-body.content .title-block {
  position: relative;
}
.result-analysis .overall-accureny .card-body.content .title-block .title {
  font: normal normal normal 15px/20px Proxima Nova;
  letter-spacing: 0px;
  color: #213046;
  opacity: 0.5;
  transform: rotate(-90deg);
  position: absolute;
  width: 215px;
  left: -115px;
  top: 50%;
  bottom: 0;
}
.result-analysis .overall-accureny .card-body.content .indicator {
  position: absolute;
  top: 0;
  left: 1px;
  display: none;
  font-size: 0.65rem;
  color: #9097A2;
}
.result-analysis .overall-accureny .card-body.content .indicator i {
  padding: 2px;
  background: #9097A2;
  border-radius: 0.2rem;
  color: #fff;
}
.result-analysis .overall-accureny .card-body.content .card .card-header .title {
  font: normal normal bold 40px/35px Proxima Nova;
  letter-spacing: 0px;
  color: #212B64;
}
.result-analysis .overall-accureny .card-body.content .card .card-header .subtitle {
  font: normal normal bold 11px/12px Proxima Nova;
  letter-spacing: 0px;
  color: #212B64;
}
.result-analysis .overall-accureny .card-body.content .card .title {
  color: #212B64;
  font: normal normal bold 30px/26px Proxima Nova;
}
.result-analysis .overall-accureny .card-body.content .card small {
  font: normal normal normal 10px/12px Proxima Nova;
  letter-spacing: 0px;
}
.result-analysis .overall-accureny .card-body.content .card .counts {
  font-size: 0.8rem;
}
.result-analysis .overall-accureny:hover .card-body.content {
  border: 1px solid #9097A2;
  border-radius: 0.4rem;
}
.result-analysis .overall-accureny:hover .card-body.content .indicator {
  display: block;
  transition: 1s all;
}
.result-analysis .subject-accureny {
  box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.1607843137);
  border-radius: 0.4rem;
  border: 1px solid #fff !important;
}
.result-analysis .subject-accureny .col:not(:last-child) {
  margin-right: 0.2rem;
}
.result-analysis .subject-accureny .title-block {
  position: relative;
}
.result-analysis .subject-accureny .title-block .title {
  font: normal normal normal 15px/20px Proxima Nova;
  letter-spacing: 0px;
  color: #213046;
  opacity: 0.5;
  transform: rotate(-90deg);
  position: absolute;
  left: -80px;
  top: 80px;
  bottom: 0;
}
.result-analysis .subject-accureny .card {
  border-top-left-radius: 0.4rem;
  border-top-right-radius: 0;
  border-bottom-left-radius: 0.4rem;
  border-bottom-right-radius: 0;
}
.result-analysis .subject-accureny .card .list-unstyled li:first-child small {
  font: normal normal normal 10px/12px Proxima Nova;
  letter-spacing: 0px;
  color: #FFFFFF;
}
.result-analysis .subject-accureny .card .list-unstyled li:first-child h3 {
  font: normal normal bold 30px/26px Proxima Nova;
  letter-spacing: 0px;
  color: #FFFFFF;
}
.result-analysis .subject-accureny .card .list-unstyled li:first-child p {
  font: normal normal bold 11px/13px Proxima Nova;
  letter-spacing: 0px;
  color: #DCF03E;
}
.result-analysis .subject-accureny .card .list-unstyled li:first-child p small {
  font: normal normal normal 15px/13px Proxima Nova;
  letter-spacing: 0px;
  color: #DCF03E;
}
.result-analysis .subject-accureny .card .content .subject-title {
  font: normal normal bold 15px/30px Segoe UI;
  letter-spacing: 0px;
  color: #FFFFFF;
  text-transform: capitalize;
}
.result-analysis .subject-accureny .card .content .suject-icon svg {
  width: 30px;
  height: 30px;
}
.result-analysis .subject-accureny .card.physics {
  background: #EE5D70;
}
.result-analysis .subject-accureny .card.chemistry {
  background: #0960CE;
}
.result-analysis .subject-accureny .card.botany {
  background: #3AC555;
}
.result-analysis .subject-accureny .card.zoology {
  background: #C37800;
}
.result-analysis .subject-accureny .card.mathematics {
  background: #01040A;
}
.result-analysis .subject-accureny .indicator {
  position: absolute;
  top: 0;
  left: 0px;
  display: none;
  font-size: 0.65rem;
  color: #9097A2;
}
.result-analysis .subject-accureny .indicator i {
  padding: 2px;
  background: #9097A2;
  border-radius: 0.2rem;
  color: #fff;
}
.result-analysis .subject-accureny:hover {
  border: 1px solid #9097A2 !important;
  border-radius: 0.4rem;
}
.result-analysis .subject-accureny:hover .indicator {
  display: block;
  transition: 1s all;
}
.result-analysis .timeAnalysis {
  overflow: hidden;
  box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.1607843137);
  border: 1px solid #ffffff !important;
  border-radius: 0.4rem;
}
.result-analysis .timeAnalysis i.fa-alarm-clock {
  font-size: 6rem;
  position: absolute;
  top: 3rem;
  color: #966FED;
  opacity: 0.1;
}
.result-analysis .timeAnalysis .card-header {
  border: 1px solid #EEEEEE;
  border-radius: 6px;
}
.result-analysis .timeAnalysis .card-body small {
  font: normal normal normal 10px/12px Proxima Nova;
  letter-spacing: 0px;
}
.result-analysis .timeAnalysis .card-body .title2 {
  font: normal normal bold 30px/26px Proxima Nova;
  color: #212B64;
}
.result-analysis .timeAnalysis .card-body .d-flex img {
  position: absolute;
  top: 15px;
  left: 10px;
}
.result-analysis .timeAnalysis .card-body .d-flex .rotateTxt {
  left: -34px;
  transform: rotate(-90deg);
  top: 45%;
  text-align: center;
  font: normal normal normal 15px/20px Proxima Nova;
  letter-spacing: 0px;
  color: #213046;
  opacity: 0.5;
  position: absolute;
}
.result-analysis .timeAnalysis .card-body .table {
  overflow: hidden;
  border-radius: 10px;
  margin-bottom: 0;
}
.result-analysis .timeAnalysis .card-body .table tbody td,
.result-analysis .timeAnalysis .card-body .table tbody th {
  padding: 0.35rem 0.75rem;
}
.result-analysis .timeAnalysis .card-footer {
  background: #eae2fc;
}
.result-analysis .timeAnalysis .card-footer .title {
  font: normal normal bold 16px/20px Proxima Nova;
  letter-spacing: 0px;
  color: #142031;
}
.result-analysis .timeAnalysis .card-footer .title2 {
  font: normal normal bold 22px/20px Proxima Nova;
  letter-spacing: 0px;
  color: #142031;
}
.result-analysis .timeAnalysis .card-footer .subtitle {
  font: normal normal normal 12px/20px Proxima Nova;
  letter-spacing: 0px;
  color: #142031;
}
.result-analysis .timeAnalysis .indicator {
  position: absolute;
  top: 0;
  left: 0px;
  display: none;
  font-size: 0.65rem;
  color: #9097A2;
}
.result-analysis .timeAnalysis .indicator i {
  padding: 2px;
  background: #9097A2;
  border-radius: 0.2rem;
  color: #fff;
}
.result-analysis .timeAnalysis:hover {
  border-color: #9097A2 !important;
  border-radius: 0.4rem;
}
.result-analysis .timeAnalysis:hover .indicator {
  display: block;
  transition: 1s all;
}
.result-analysis .complexity-accuracy .table.out-table tr th,
.result-analysis .complexity-accuracy .table.out-table tr td {
  font-weight: 600;
  padding: 0.45rem 0.65rem;
  border: none;
}
.result-analysis .complexity-accuracy .table.out-table tr th h6 {
  margin-bottom: 0.2rem;
  font-size: 0.9rem;
}
.result-analysis .complexity-accuracy .table.out-table tr th p {
  font-size: 9px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.result-analysis .complexity-accuracy .complexity-accuracy-table {
  box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.1607843137);
  border: 1px solid #fff !important;
}
.result-analysis .complexity-accuracy .complexity-accuracy-table .title {
  font-size: 0.65rem;
}
.result-analysis .complexity-accuracy .complexity-accuracy-table .icon {
  margin-right: 0.2rem;
}
.result-analysis .complexity-accuracy .complexity-accuracy-table .icon svg {
  width: 18px;
  height: 18px;
}
.result-analysis .complexity-accuracy .complexity-accuracy-table .title-block {
  position: relative;
}
.result-analysis .complexity-accuracy .complexity-accuracy-table .title-block .title {
  font: normal normal normal 15px/20px Proxima Nova;
  letter-spacing: 0px;
  color: #213046;
  margin: 50px -100px;
  transform: rotate(-90deg);
  position: absolute;
  width: 215px;
  left: 0;
  text-transform: capitalize;
  opacity: 0.5;
}
.result-analysis .complexity-accuracy .complexity-accuracy-table .card {
  border-radius: 0;
}
.result-analysis .complexity-accuracy .complexity-accuracy-table .card.easy {
  background: transparent linear-gradient(180deg, #FFFFFF 0%, #19CBA0 100%);
}
.result-analysis .complexity-accuracy .complexity-accuracy-table .card.moderate {
  background: transparent linear-gradient(180deg, #FFFFFF 0%, #FFC107 100%);
}
.result-analysis .complexity-accuracy .complexity-accuracy-table .card.difficult {
  background: transparent linear-gradient(180deg, #FFFFFF 0%, #F05D70 100%);
}
.result-analysis .complexity-accuracy .complexity-accuracy-table .card.high-difficult {
  background: transparent linear-gradient(180deg, #FFFFFF 0%, #FF0000 100%);
}
.result-analysis .complexity-accuracy .complexity-accuracy-table .card .card .table thead tr th {
  padding: 0.45rem 0rem !important;
  border: none;
  text-align: left;
}
.result-analysis .complexity-accuracy .complexity-accuracy-table .card .card .table tbody tr td {
  padding: 0.45rem 0rem !important;
  border: none;
  font-weight: 600;
  text-align: center;
}
.result-analysis .complexity-accuracy .complexity-accuracy-table .indicator {
  position: absolute;
  top: 0;
  left: 0px;
  display: none;
  font-size: 0.65rem;
  color: #9097A2;
}
.result-analysis .complexity-accuracy .complexity-accuracy-table .indicator i {
  padding: 2px;
  background: #9097A2;
  border-radius: 0.2rem;
  color: #fff;
}
.result-analysis .complexity-accuracy .complexity-accuracy-table:hover {
  border: 1px solid #9097A2 !important;
  border-radius: 0.4rem;
}
.result-analysis .complexity-accuracy .complexity-accuracy-table:hover .indicator {
  display: block;
  transition: 1s all;
}
.result-analysis .complexity-accuracy .top-weeks {
  box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.1607843137);
  border: 1px solid #fff !important;
}
.result-analysis .complexity-accuracy .top-weeks .title-block {
  position: relative;
}
.result-analysis .complexity-accuracy .top-weeks .title-block .title {
  font: normal normal normal 15px/20px Proxima Nova;
  letter-spacing: 0px;
  color: #213046;
  opacity: 0.5;
  margin: 40px -102px;
  transform: rotate(-90deg);
  position: absolute;
  width: 215px;
  left: 0;
}
.result-analysis .complexity-accuracy .top-weeks .table tbody tr td {
  font-weight: 600;
  padding: 6px 8px;
  background: #EEEEEE;
  border-top: 2px solid #fff;
  font-size: 11.5px;
}
.result-analysis .complexity-accuracy .top-weeks .table tbody tr td:first-child {
  border-top-left-radius: 0.4rem;
  border-bottom-left-radius: 0.4rem;
}
.result-analysis .complexity-accuracy .top-weeks .table tbody tr td:last-child {
  border-top-right-radius: 0.4rem;
  border-bottom-right-radius: 0.4rem;
}
.result-analysis .complexity-accuracy .top-weeks .indicator {
  position: absolute;
  top: 0;
  left: 0px;
  display: none;
  font-size: 0.65rem;
  color: #9097A2;
}
.result-analysis .complexity-accuracy .top-weeks .indicator i {
  padding: 2px;
  background: #9097A2;
  border-radius: 0.2rem;
  color: #fff;
}
.result-analysis .complexity-accuracy .top-weeks:hover {
  border: 1px solid #9097A2 !important;
  border-radius: 0.4rem;
}
.result-analysis .complexity-accuracy .top-weeks:hover .indicator {
  display: block;
  transition: 1s all;
}
.result-analysis .question-theory .question-theory-block {
  background: #FFC107;
  box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.1607843137);
}
.result-analysis .question-theory .title-block {
  position: relative;
}
.result-analysis .question-theory .title-block .title {
  font: normal normal normal 15px/15px Proxima Nova;
  letter-spacing: 0px;
  color: #213046;
  margin: 14px -30px;
  transform: rotate(-90deg);
  position: absolute;
  width: 70px;
  left: 0;
  text-transform: capitalize;
  opacity: 0.5;
}
.result-analysis .question-theory .tables-block {
  position: relative;
  z-index: 1;
}
.result-analysis .question-theory .list-one {
  position: relative;
}
.result-analysis .question-theory .list-one li {
  position: absolute;
}
.result-analysis .question-theory .list-one li:nth-child(1) {
  font-size: 4rem;
  color: rgba(255, 255, 255, 0.1607843137);
  left: 28px;
  bottom: -10px;
}
.result-analysis .question-theory .list-one li:nth-child(2) {
  font-size: 5rem;
  color: rgba(255, 255, 255, 0.1607843137);
  left: 60px;
  bottom: -10px;
}
.result-analysis .question-theory .list-one li:nth-child(3) {
  font-size: 2.5rem;
  color: rgba(255, 255, 255, 0.1607843137);
  left: 8px;
  bottom: -19px;
}
.result-analysis .question-theory .list-two {
  position: relative;
}
.result-analysis .question-theory .list-two li {
  position: absolute;
}
.result-analysis .question-theory .list-two li:nth-child(1) {
  font-size: 4rem;
  color: rgba(255, 255, 255, 0.1607843137);
  right: 80px;
  bottom: -20px;
}
.result-analysis .question-theory .list-two li:nth-child(2) {
  font-size: 5rem;
  color: rgba(255, 255, 255, 0.1607843137);
  right: 30px;
  bottom: -10px;
}`, "",{"version":3,"sources":["webpack://./src/_config.scss","webpack://./src/student_module/components/analysis/result_analysis/_resultanalysis.scss"],"names":[],"mappings":"AAkCA;EACI,mDAAA;AC9BJ;;ADiCA;EACI,yBAAA;AC9BJ;;ADiCA;EACI,yBAAA;AC9BJ;;ADiCA;EACI,gCAAA;AC9BJ;;ADiCA;EACI,yBAAA;AC9BJ;;ADiCA;EACI,yBAAA;AC9BJ;;ADiCA;EACI,yBAAA;AC9BJ;;ADiCA;EACI,8BAAA;AC9BJ;;ADiCA;EACI,8BAAA;AC9BJ;;ADiCA;EACI,yBAAA;AC9BJ;;ADiCA;EACI,yBAAA;AC9BJ;;ADiCA;EACI,yBAAA;AC9BJ;;ADiCA;EACI,gCAAA;AC9BJ;;ADkCA;;gDAAA;AAIA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;AChCJ;ADkCI;EAMI,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,iDAAA;ACrCR;;ADyCA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,6BAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;ACtCJ;ADwCI;EAMI,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,iDAAA;AC3CR;;AD+CA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;AC5CJ;AD8CI;EAMI,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,iDAAA;ACjDR;;ADqDA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;AClDJ;ADoDI;EAMI,cAAA;EACA,yBAAA;EACA,yBAAA;EACA,iDAAA;ACvDR;;AD2DA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,4CAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;ACxDJ;AD0DI;EAMI,cAAA;EACA,2CAAA;EACA,yBAAA;EACA,iDAAA;AC7DR;;ADiEA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,mBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;AC9DJ;ADgEI;EAMI,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,iDAAA;ACnER;;ADuEA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,mBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;ACpEJ;ADsEI;EAMI,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,iDAAA;ACzER;;AD6EA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;AC1EJ;AD4EI;EAMI,cAAA;EACA,yBAAA;EACA,yBAAA;EACA,iDAAA;AC/ER;;ADoFA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;ACjFJ;ADmFI;EAMI,cAAA;EACA,yBAAA;EACA,yBAAA;EACA,iDAAA;ACtFR;;AD0FA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;ACvFJ;ADyFI;EAMI,cAAA;EACA,yBAAA;EACA,yBAAA;EACA,iDAAA;AC5FR;;AD+FA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;AC5FJ;AD8FI;EAMI,cAAA;EACA,yBAAA;EACA,yBAAA;EACA,iDAAA;ACjGR;;ADqGA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;AClGJ;ADqGI;EAMI,cAAA;EACA,yBAAA;EACA,yBAAA;EACA,iDAAA;ACxGR;;AD4GA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oBAAA;EACA,iDAAA;ACzGJ;AD2GI;EAMI,cAAA;EACA,yBAAA;EACA,yBAAA;EACA,iDAAA;AC9GR;;AA7WA;EACI,kBAAA;AAgXJ;AA9VI;EACI,WAAA;EACA,YAAA;EACA,WAAA;EACA,OAAA;EACA,MAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;AAgWR;AA7VI;EACI,kBAAA;EACA,gBAAA;EACA,UAAA;AA+VR;AA7VQ;EACI,mBAAA;AA+VZ;AA7VY;EACI,cAAA;AA+VhB;AA5VY;EACI,6CAAA;EACA,mDAAA;EACA,mBAAA;AA8VhB;AA5VgB;EACI,WAAA;EACA,YAAA;AA8VpB;AA1VoB;EACI,eAAA;EACA,gBAAA;AA4VxB;AAtVQ;EACI,cAAA;EACA,6CAAA;EACA,gBAAA;AAwVZ;AArVQ;EACI,iBAAA;AAuVZ;AAnVI;EACI,kBAAA;EACA,UAAA;AAqVR;AAnVQ;EACI,yCAAA;EACA,mBAAA;AAqVZ;AAnVY;EACI,iBAAA;EACA,mBAAA;AAqVhB;AAhVY;EACI,cAAA;EACA,kBAAA;EACA,UAAA;EACA,MAAA;EACA,eAAA;EACA,6CAAA;EACA,aAAA;EACA,kBAAA;AAkVhB;AA/UY;EACI,kBAAA;EACA,yCAAA;EACA,cAAA;AAiVhB;AA/UgB;EACI,cAAA;AAiVpB;AA7UY;EACI,QAAA;AA+UhB;;AAzUA;EACI,qBAAA;AA4UJ;;AAxUI;EACI,oDAAA;EACA,qBAAA;AA2UR;AAzUQ;EACI,6BAAA;AA2UZ;AAzUY;EACI,kBAAA;AA2UhB;AAzUgB;EACI,iDAAA;EACA,mBAAA;EACA,cAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,QAAA;EACA,SAAA;AA2UpB;AAvUY;EACI,kBAAA;EACA,MAAA;EACA,SAAA;EACA,aAAA;EACA,kBAAA;EACA,cAAA;AAyUhB;AAvUgB;EACI,YAAA;EACA,mBAAA;EACA,qBAAA;EACA,WAAA;AAyUpB;AAnUoB;EACI,+CAAA;EACA,mBAAA;EACA,cAAA;AAqUxB;AAlUoB;EACI,+CAAA;EACA,mBAAA;EACA,cAAA;AAoUxB;AAhUgB;EACI,cAAA;EAEA,+CAAA;AAiUpB;AA/TgB;EACI,iDAAA;EACA,mBAAA;AAiUpB;AA9TgB;EACI,iBAAA;AAgUpB;AA3TQ;EACI,yBAAA;EACA,qBAAA;AA6TZ;AA1TY;EACI,cAAA;EACA,kBAAA;AA4ThB;AAvTI;EACI,oDAAA;EACA,qBAAA;EACA,iCAAA;AAyTR;AAvTQ;EACI,oBAAA;AAyTZ;AAtTQ;EACI,kBAAA;AAwTZ;AAtTY;EACI,iDAAA;EACA,mBAAA;EACA,cAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,SAAA;AAwThB;AApTQ;EACI,8BAAA;EACA,0BAAA;EACA,iCAAA;EACA,6BAAA;AAsTZ;AAlToB;EACI,iDAAA;EACA,mBAAA;EACA,cAAA;AAoTxB;AAjToB;EACI,+CAAA;EACA,mBAAA;EACA,cAAA;AAmTxB;AA/SoB;EACI,+CAAA;EACA,mBAAA;EACA,cAAA;AAiTxB;AA/SwB;EACI,iDAAA;EACA,mBAAA;EACA,cAAA;AAiT5B;AAxSgB;EACI,2CAAA;EACA,mBAAA;EACA,cAAA;EAMA,0BAAA;AAqSpB;AA7RoB;EACI,WAAA;EACA,YAAA;AA+RxB;AA1RY;EACI,mBAAA;AA4RhB;AAzRY;EACI,mBAAA;AA2RhB;AAxRY;EACI,mBAAA;AA0RhB;AAvRY;EACI,mBAAA;AAyRhB;AAtRY;EACI,mBAAA;AAwRhB;AApRQ;EACI,kBAAA;EACA,MAAA;EACA,SAAA;EACA,aAAA;EACA,kBAAA;EACA,cAAA;AAsRZ;AApRY;EACI,YAAA;EACA,mBAAA;EACA,qBAAA;EACA,WAAA;AAsRhB;AAlRQ;EACI,oCAAA;EACA,qBAAA;AAoRZ;AAlRY;EACI,cAAA;EACA,kBAAA;AAoRhB;AA/QI;EACI,gBAAA;EACA,oDAAA;EACA,oCAAA;EACA,qBAAA;AAiRR;AA/QQ;EACI,eAAA;EACA,kBAAA;EACA,SAAA;EACA,cAAA;EACA,YAAA;AAiRZ;AA9QQ;EACI,yBAAA;EACA,kBAAA;AAgRZ;AA5QY;EACI,iDAAA;EACA,mBAAA;AA8QhB;AA5QY;EACI,+CAAA;EACA,cAAA;AA8QhB;AA1QgB;EACI,kBAAA;EACA,SAAA;EACA,UAAA;AA4QpB;AAzQgB;EACI,WAAA;EACA,yBAAA;EACA,QAAA;EACA,kBAAA;EACA,iDAAA;EACA,mBAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;AA2QpB;AAvQY;EACI,gBAAA;EACA,mBAAA;EACA,gBAAA;AAyQhB;AArQoB;;EAEI,wBAAA;AAuQxB;AAjQQ;EACI,mBAAA;AAmQZ;AAjQY;EACI,+CAAA;EACA,mBAAA;EACA,cAAA;AAmQhB;AAhQY;EACI,+CAAA;EACA,mBAAA;EACA,cAAA;AAkQhB;AA/PY;EACI,iDAAA;EACA,mBAAA;EACA,cAAA;AAiQhB;AA7PQ;EACI,kBAAA;EACA,MAAA;EACA,SAAA;EACA,aAAA;EACA,kBAAA;EACA,cAAA;AA+PZ;AA7PY;EACI,YAAA;EACA,mBAAA;EACA,qBAAA;EACA,WAAA;AA+PhB;AA3PQ;EACI,gCAAA;EACA,qBAAA;AA6PZ;AA3PY;EACI,cAAA;EACA,kBAAA;AA6PhB;AApPY;;EAEI,gBAAA;EACA,wBAAA;EACA,YAAA;AAsPhB;AAlPgB;EACI,qBAAA;EACA,iBAAA;AAoPpB;AAjPgB;EACI,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAmPpB;AA7OQ;EACI,oDAAA;EACA,iCAAA;AA+OZ;AA7OY;EACI,kBAAA;AA+OhB;AA5OY;EACI,oBAAA;AA8OhB;AA5OgB;EACI,WAAA;EACA,YAAA;AA8OpB;AA1OY;EACI,kBAAA;AA4OhB;AA1OgB;EACI,iDAAA;EACA,mBAAA;EACA,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,OAAA;EACA,0BAAA;EACA,YAAA;AA4OpB;AAxOY;EACI,gBAAA;AA0OhB;AAxOgB;EACI,yEAAA;AA0OpB;AAvOgB;EACI,yEAAA;AAyOpB;AAtOgB;EACI,yEAAA;AAwOpB;AArOgB;EACI,yEAAA;AAuOpB;AAlOwB;EACI,gCAAA;EACA,YAAA;EACA,gBAAA;AAoO5B;AA/NwB;EACI,gCAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;AAiO5B;AA3NY;EACI,kBAAA;EACA,MAAA;EACA,SAAA;EACA,aAAA;EACA,kBAAA;EACA,cAAA;AA6NhB;AA3NgB;EACI,YAAA;EACA,mBAAA;EACA,qBAAA;EACA,WAAA;AA6NpB;AAzNY;EACI,oCAAA;EACA,qBAAA;AA2NhB;AAzNgB;EACI,cAAA;EACA,kBAAA;AA2NpB;AArNQ;EACI,oDAAA;EACA,iCAAA;AAuNZ;AArNY;EACI,kBAAA;AAuNhB;AArNgB;EACI,iDAAA;EACA,mBAAA;EACA,cAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,OAAA;AAuNpB;AA/MoB;EACI,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,0BAAA;EACA,iBAAA;AAiNxB;AA/MwB;EACI,8BAAA;EACA,iCAAA;AAiN5B;AA9MwB;EACI,+BAAA;EACA,kCAAA;AAgN5B;AA1MY;EACI,kBAAA;EACA,MAAA;EACA,SAAA;EACA,aAAA;EACA,kBAAA;EACA,cAAA;AA4MhB;AA1MgB;EACI,YAAA;EACA,mBAAA;EACA,qBAAA;EACA,WAAA;AA4MpB;AAxMY;EACI,oCAAA;EACA,qBAAA;AA0MhB;AAxMgB;EACI,cAAA;EACA,kBAAA;AA0MpB;AAnMQ;EACI,mBAAA;EACA,oDAAA;AAqMZ;AAlMQ;EACI,kBAAA;AAoMZ;AAlMY;EACI,iDAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,OAAA;EACA,0BAAA;EACA,YAAA;AAoMhB;AAhMQ;EACI,kBAAA;EACA,UAAA;AAkMZ;AA/LQ;EACI,kBAAA;AAiMZ;AA/LY;EACI,kBAAA;AAiMhB;AA/LgB;EACI,eAAA;EACA,wCAAA;EACA,UAAA;EACA,aAAA;AAiMpB;AA9LgB;EACI,eAAA;EACA,wCAAA;EACA,UAAA;EACA,aAAA;AAgMpB;AA7LgB;EACI,iBAAA;EACA,wCAAA;EACA,SAAA;EACA,aAAA;AA+LpB;AA1LQ;EACI,kBAAA;AA4LZ;AA1LY;EACI,kBAAA;AA4LhB;AA1LgB;EACI,eAAA;EACA,wCAAA;EACA,WAAA;EACA,aAAA;AA4LpB;AAzLgB;EACI,eAAA;EACA,wCAAA;EACA,WAAA;EACA,aAAA;AA2LpB","sourcesContent":["// @import url('https://fonts.googleapis.com/css?family=Ubuntu:300,300i,400,400i,500,500i,700,700i&display=swap');\n@import url('https://fonts.googleapis.com/css?family=Proxima%20Nova:300,300i,400,400i,500,500i,700,700i');\n@import url('https://fonts.googleapis.com/css2?family=Titillium+Web:ital,wght@0,200;0,300;0,400;0,600;0,700;0,900;1,200;1,300;1,400;1,600;1,700&display=swap');\n@import url(\"https://use.typekit.net/ija5zmr.css\");\n\n$theme1: #36A1F5;\n$theme2: #1B2430;\n$white: #ffffff;\n$gray: #ced4da;\n$gray-2: #F2F2F2;\n$gray-3: #E5E5E5;\n$gray-4: #707070;\n$gray-5: #969DAA;\n$green: #01b306;\n$blue: #231c86;\n// #e7e9ea\n$one: #52B8FA;\n$two: #FAEF52;\n$three: #FABC52;\n$four: #AC52FA;\n$five: #FA52C2;\n$six: #FA5252;\n\n// $font-family: 'Ubuntu', sans-serif !important;\n$font-family: 'proxima-nova',\nsans-serif !important;\n\n@mixin fonts ($fontWeight, $fontSize, $lineHeight) {\n    font-family: $font-family;\n    font-size: $fontSize !important;\n    font-weight: $fontWeight !important;\n    line-height: $lineHeight;\n}\n\n.titilliumweb_font {\n    font-family: 'Titillium Web', sans-serif !important;\n}\n\n.text-gray4 {\n    color: $gray-4 !important;\n}\n\n.text-gray3 {\n    color: $gray-3 !important;\n}\n\n.border-theme {\n    border-color: $gray !important;\n}\n\n.text-theme {\n    color: $theme1 !important;\n}\n\n.text-blue {\n    color: $blue !important;\n}\n\n.theme-info {\n    color: #00C2FF !important;\n}\n\n.bg-theme {\n    background: $theme1 !important;\n}\n\n.bg-darkblue {\n    background: #212B65 !important;\n}\n\n.theme-red {\n    color: #ff0000 !important;\n}\n\n.theme-purple {\n    color: #A300FF !important;\n}\n\n.theme-darkblue {\n    color: #212B64 !important;\n}\n\n.border-darkblue {\n    border-color: #212B65 !important;\n}\n\n\n/*----------------------------------------------\n    Buttons\n-----------------------------------------------*/\n\n.btn-white {\n    font-weight: 400;\n    color: #000000;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background-color: #ffffff;\n    border: 1px solid #ffffff;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #000000;\n        background: #f1f3f5;\n        border: 1px solid #f1f3f5;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n\n.btn-white-outline {\n    font-weight: 400;\n    color: #707070;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background-color: transparent;\n    border: 1px solid #ced4da;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #707070;\n        background: #f1f3f5;\n        border: 1px solid #ced4da;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n\n.btn-black {\n    font-weight: 400;\n    color: #ffffff;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background-color: #000000;\n    border: 1px solid #000000;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #ffffff;\n        background: #212529;\n        border: 1px solid #212529;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n\n.btn-green {\n    font-weight: 400;\n    color: #ffffff;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background-color: #00C596;\n    border: 1px solid #00C596;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #ffffff;\n        background-color: #00a780;\n        border: 1px solid #00a780;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n\n.btn-lightgreen {\n    font-weight: 400;\n    color: #00C596;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background-color: hsla(166, 100%, 39%, 0.11);\n    border: 1px solid #00C596;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #00C596;\n        background-color: hsla(166, 100%, 39%, 0.4);\n        border: 1px solid #009b77;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n\n.btn-darkblue {\n    font-weight: 400;\n    color: #ffffff;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background: #202B63;\n    border: 1px solid #3A4789;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #ffffff;\n        background: #1c2658;\n        border: 1px solid #303b74;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n\n.btn-darkblue-outline {\n    font-weight: 400;\n    color: #202B63;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background: #ffffff;\n    border: 1px solid #3A4789;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #ffffff;\n        background: #202B63;\n        border: 1px solid #3A4789;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n\n.btn-blue {\n    font-weight: 400;\n    color: #ffffff;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background-color: #077EE6;\n    border: 1px solid #077EE6;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #ffffff;\n        background-color: #0172d4;\n        border: 1px solid #0172d4;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n\n\n.btn-blue-outline {\n    font-weight: 400;\n    color: #077EE6;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background-color: #ffffff;\n    border: 1px solid #077EE6;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #ffffff;\n        background-color: #077EE6;\n        border: 1px solid #077EE6;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n\n.btn-lightblue {\n    font-weight: 400;\n    color: #ffffff;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background-color: #36A1F5;\n    border: 1px solid #36A1F5;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #ffffff;\n        background-color: #2aa0fa;\n        border: 1px solid #2aa0fa;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n.btn-lightblue-outline {\n    font-weight: 400;\n    color: #36A1F5;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background-color: #F2F9FF;\n    border: 1px solid #36A1F5;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #ffffff;\n        background-color: #36A1F5;\n        border: 1px solid #36A1F5;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n\n.btn-lightred {\n    font-weight: 400;\n    color: #CB3F3F;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background-color: #FFEFEF;\n    border: 1px solid #FF004E;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #CB3F3F;\n        background-color: #fda3a3;\n        border: 1px solid #FF004E;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}\n\n.btn-lightOrange {\n    font-weight: 400;\n    color: #feb019;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n    user-select: none;\n    background-color: #f8efde;\n    border: 1px solid #feb019;\n    padding: 0.5rem 0.75rem;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 0.2rem;\n    text-transform: uppercase;\n    transition: all 0.5s;\n    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n\n    &:hover,\n    &:active,\n    &:focus,\n    &:not(:disabled):not(.disabled):active:focus,\n    &:not(:disabled):not(.disabled).active:focus,\n    &:not(:disabled):not(.disabled):active {\n        color: #feb019;\n        background-color: #fce9c5;\n        border: 1px solid #feb019;\n        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, .1);\n    }\n}","@import '../../../../_config.scss';\n\n\n.result-analysis-nav {\n    position: relative;\n\n    // &::before {\n    //     content: '';\n    //     height: 100%;\n    //     width: 100%;\n    //     left: 0;\n    //     top: 0;\n    //     position: absolute;\n    //     background: url('../../../../images/result-analysis-bg.png');\n    //     background-repeat: no-repeat;\n    //     background-position: top center;\n    //     background-size: cover;\n    //     opacity: 1;\n    //     filter: blur(4px);\n    //     overflow: hidden;\n    // }\n\n    &::after {\n        content: '';\n        height: 100%;\n        width: 100%;\n        left: 0;\n        top: 0;\n        position: absolute;\n        background: #077EE6;\n        opacity: 0.6;\n    }\n\n    .header-top {\n        position: relative;\n        box-shadow: none;\n        z-index: 2;\n\n        .navbar-nav {\n            align-items: center;\n\n            .nav-link {\n                color: #ffffff;\n            }\n\n            .profile-img {\n                background: #ffffff1f;\n                border: 1px solid #ffffff17;\n                border-radius: 21px;\n\n                img {\n                    width: 35px;\n                    height: 35px;\n                }\n\n                .text {\n                    .profile-name {\n                        font-size: 14px;\n                        line-height: 6px;\n                    }\n                }\n            }\n        }\n\n        .search .search-bar {\n            color: #ffffff;\n            background: #ffffff17;\n            box-shadow: none;\n        }\n\n        .student-notification i {\n            font-size: 1.5rem;\n        }\n    }\n\n    .header-bottom {\n        position: relative;\n        z-index: 1;\n\n        .card {\n            background-color: hsla(0, 0%, 100%, 0.46);\n            border-radius: 10px;\n\n            img {\n                margin-top: -3rem;\n                margin-bottom: 10px;\n            }\n        }\n\n        .datePicker {\n            .calendar {\n                color: #ffffff;\n                position: absolute;\n                left: 15px;\n                top: 0;\n                font-size: 18px;\n                background: #ffffff75;\n                padding: 10px;\n                border-radius: 4px;\n            }\n\n            .form-control {\n                padding-left: 40px;\n                background-color: hsla(0, 0%, 100%, 0.46);\n                color: #ffffff;\n\n                &::placeholder {\n                    color: #ffffff;\n                }\n            }\n\n            .rdtPicker {\n                right: 0;\n            }\n        }\n    }\n}\n\n.w-35 {\n    width: 35% !important;\n}\n\n.result-analysis {\n    .overall-accureny {\n        box-shadow: 0px 3px 20px #00000029;\n        border-radius: 0.4rem;\n\n        .card-body.content {\n            border: 1px solid transparent;\n\n            .title-block {\n                position: relative;\n\n                .title {\n                    font: normal normal normal 15px/20px Proxima Nova;\n                    letter-spacing: 0px;\n                    color: #213046;\n                    opacity: 0.5;\n                    transform: rotate(-90deg);\n                    position: absolute;\n                    width: 215px;\n                    left: -115px;\n                    top: 50%;\n                    bottom: 0;\n                }\n            }\n\n            .indicator {\n                position: absolute;\n                top: 0;\n                left: 1px;\n                display: none;\n                font-size: 0.65rem;\n                color: #9097A2;\n\n                i {\n                    padding: 2px;\n                    background: #9097A2;\n                    border-radius: 0.2rem;\n                    color: #fff;\n                }\n            }\n\n            .card {\n                .card-header {\n                    .title {\n                        font: normal normal bold 40px/35px Proxima Nova;\n                        letter-spacing: 0px;\n                        color: #212B64;\n                    }\n\n                    .subtitle {\n                        font: normal normal bold 11px/12px Proxima Nova;\n                        letter-spacing: 0px;\n                        color: #212B64;\n                    }\n                }\n\n                .title {\n                    color: #212B64;\n                    // font-size: 0.7rem;\n                    font: normal normal bold 30px/26px Proxima Nova;\n                }\n                small {\n                    font: normal normal normal 10px/12px Proxima Nova;\n                    letter-spacing: 0px;\n                }\n\n                .counts {\n                    font-size: .8rem;\n                }\n            }\n        }\n\n        &:hover .card-body.content {\n            border: 1px solid #9097A2;\n            border-radius: 0.4rem;\n\n\n            .indicator {\n                display: block;\n                transition: 1s all;\n            }\n        }\n    }\n\n    .subject-accureny {\n        box-shadow: 0px 3px 20px #00000029;\n        border-radius: 0.4rem;\n        border: 1px solid #fff !important;\n\n        .col:not(:last-child) {\n            margin-right: .2rem;\n        }\n\n        .title-block {\n            position: relative;\n\n            .title {\n                font: normal normal normal 15px/20px Proxima Nova;\n                letter-spacing: 0px;\n                color: #213046;\n                opacity: 0.5;\n                transform: rotate(-90deg);\n                position: absolute;\n                left: -80px;\n                top: 80px;\n                bottom: 0;\n            }\n        }\n\n        .card {\n            border-top-left-radius: 0.4rem;\n            border-top-right-radius: 0;\n            border-bottom-left-radius: 0.4rem;\n            border-bottom-right-radius: 0;\n\n            .list-unstyled li {\n                &:first-child {\n                    small {\n                        font: normal normal normal 10px/12px Proxima Nova;\n                        letter-spacing: 0px;\n                        color: #FFFFFF;\n                    }\n\n                    h3 {\n                        font: normal normal bold 30px/26px Proxima Nova;\n                        letter-spacing: 0px;\n                        color: #FFFFFF;\n\n                    }\n\n                    p {\n                        font: normal normal bold 11px/13px Proxima Nova;\n                        letter-spacing: 0px;\n                        color: #DCF03E;\n\n                        small {\n                            font: normal normal normal 15px/13px Proxima Nova;\n                            letter-spacing: 0px;\n                            color: #DCF03E;\n                        }\n                    }\n                }\n            }\n\n            .content {\n                // height: 84px;\n\n                .subject-title {\n                    font: normal normal bold 15px/30px Segoe UI;\n                    letter-spacing: 0px;\n                    color: #FFFFFF;\n                    // margin: 48px 0;\n                    // transform: rotate(-90deg);\n                    // position: absolute;\n                    // width: 120px;\n                    // right: 0;\n                    text-transform: capitalize;\n                }\n\n                .suject-icon {\n                    // position: absolute;\n                    // bottom: 10px;\n                    // z-index: 1;\n\n                    svg {\n                        width: 30px;\n                        height: 30px;\n                    }\n                }\n            }\n\n            &.physics {\n                background: #EE5D70;\n            }\n\n            &.chemistry {\n                background: #0960CE;\n            }\n\n            &.botany {\n                background: #3AC555;\n            }\n\n            &.zoology {\n                background: #C37800;\n            }\n\n            &.mathematics {\n                background: #01040A;\n            }\n        }\n\n        .indicator {\n            position: absolute;\n            top: 0;\n            left: 0px;\n            display: none;\n            font-size: 0.65rem;\n            color: #9097A2;\n\n            i {\n                padding: 2px;\n                background: #9097A2;\n                border-radius: 0.2rem;\n                color: #fff;\n            }\n        }\n\n        &:hover {\n            border: 1px solid #9097A2 !important;\n            border-radius: 0.4rem;\n\n            .indicator {\n                display: block;\n                transition: 1s all;\n            }\n        }\n    }\n\n    .timeAnalysis {\n        overflow: hidden;\n        box-shadow: 0px 3px 20px #00000029;\n        border: 1px solid #ffffff !important;\n        border-radius: 0.4rem;\n\n        i.fa-alarm-clock {\n            font-size: 6rem;\n            position: absolute;\n            top: 3rem;\n            color: #966FED;\n            opacity: 0.1;\n        }\n\n        .card-header {\n            border: 1px solid #EEEEEE;\n            border-radius: 6px;\n        }\n\n        .card-body {\n            small {\n                font: normal normal normal 10px/12px Proxima Nova;\n                letter-spacing: 0px;\n            }\n            .title2 {\n                font: normal normal bold 30px/26px Proxima Nova;\n                color: #212B64;\n            }\n            \n            .d-flex {\n                img {\n                    position: absolute;\n                    top: 15px;\n                    left: 10px;\n                }\n\n                .rotateTxt {\n                    left: -34px;\n                    transform: rotate(-90deg);\n                    top: 45%;\n                    text-align: center;\n                    font: normal normal normal 15px/20px Proxima Nova;\n                    letter-spacing: 0px;\n                    color: #213046;\n                    opacity: 0.5;\n                    position: absolute;\n                }\n            }\n\n            .table {\n                overflow: hidden;\n                border-radius: 10px;\n                margin-bottom: 0;\n\n                tbody {\n\n                    td,\n                    th {\n                        padding: 0.35rem 0.75rem;\n                    }\n                }\n            }\n        }\n\n        .card-footer {\n            background: #eae2fc;\n\n            .title {\n                font: normal normal bold 16px/20px Proxima Nova;\n                letter-spacing: 0px;\n                color: #142031;\n            }\n\n            .title2 {\n                font: normal normal bold 22px/20px Proxima Nova;\n                letter-spacing: 0px;\n                color: #142031;\n            }\n\n            .subtitle {\n                font: normal normal normal 12px/20px Proxima Nova;\n                letter-spacing: 0px;\n                color: #142031;\n            }\n        }\n\n        .indicator {\n            position: absolute;\n            top: 0;\n            left: 0px;\n            display: none;\n            font-size: 0.65rem;\n            color: #9097A2;\n\n            i {\n                padding: 2px;\n                background: #9097A2;\n                border-radius: 0.2rem;\n                color: #fff;\n            }\n        }\n\n        &:hover {\n            border-color: #9097A2 !important;\n            border-radius: 0.4rem;\n\n            .indicator {\n                display: block;\n                transition: 1s all;\n            }\n        }\n    }\n\n    .complexity-accuracy {\n\n        .table.out-table {\n\n            tr th,\n            tr td {\n                font-weight: 600;\n                padding: .45rem .65rem;\n                border: none;\n            }\n\n            tr th {\n                h6 {\n                    margin-bottom: 0.2rem;\n                    font-size: 0.9rem;\n                }\n\n                p {\n                    font-size: 9px;\n                    white-space: nowrap;\n                    overflow: hidden;\n                    text-overflow: ellipsis;\n                }\n            }\n\n        }\n\n        .complexity-accuracy-table {\n            box-shadow: 0px 3px 20px #00000029;\n            border: 1px solid #fff !important;\n\n            .title {\n                font-size: .65rem;\n            }\n\n            .icon {\n                margin-right: .2rem;\n\n                svg {\n                    width: 18px;\n                    height: 18px;\n                }\n            }\n\n            .title-block {\n                position: relative;\n\n                .title {\n                    font: normal normal normal 15px/20px Proxima Nova;\n                    letter-spacing: 0px;\n                    color: #213046;\n                    margin: 50px -100px;\n                    transform: rotate(-90deg);\n                    position: absolute;\n                    width: 215px;\n                    left: 0;\n                    text-transform: capitalize;\n                    opacity: 0.5;\n                }\n            }\n\n            .card {\n                border-radius: 0;\n\n                &.easy {\n                    background: transparent linear-gradient(180deg, #FFFFFF 0%, #19CBA0 100%)\n                }\n\n                &.moderate {\n                    background: transparent linear-gradient(180deg, #FFFFFF 0%, #FFC107 100%);\n                }\n\n                &.difficult {\n                    background: transparent linear-gradient(180deg, #FFFFFF 0%, #F05D70 100%);\n                }\n\n                &.high-difficult {\n                    background: transparent linear-gradient(180deg, #FFFFFF 0%, #FF0000 100%);\n                }\n\n                .card .table {\n                    thead tr {\n                        th {\n                            padding: .45rem 0rem !important;\n                            border: none;\n                            text-align: left;\n                        }\n                    }\n\n                    tbody tr {\n                        td {\n                            padding: .45rem 0rem !important;\n                            border: none;\n                            font-weight: 600;\n                            text-align: center;\n                        }\n                    }\n                }\n            }\n\n            .indicator {\n                position: absolute;\n                top: 0;\n                left: 0px;\n                display: none;\n                font-size: 0.65rem;\n                color: #9097A2;\n\n                i {\n                    padding: 2px;\n                    background: #9097A2;\n                    border-radius: 0.2rem;\n                    color: #fff;\n                }\n            }\n\n            &:hover {\n                border: 1px solid #9097A2 !important;\n                border-radius: 0.4rem;\n\n                .indicator {\n                    display: block;\n                    transition: 1s all;\n                }\n            }\n\n        }\n\n        .top-weeks {\n            box-shadow: 0px 3px 20px #00000029;\n            border: 1px solid #fff !important;\n\n            .title-block {\n                position: relative;\n\n                .title {\n                    font: normal normal normal 15px/20px Proxima Nova;\n                    letter-spacing: 0px;\n                    color: #213046;\n                    opacity: 0.5;\n                    margin: 40px -102px;\n                    transform: rotate(-90deg);\n                    position: absolute;\n                    width: 215px;\n                    left: 0;\n                }\n            }\n\n            .table tbody {\n                tr {\n\n\n                    td {\n                        font-weight: 600;\n                        padding: 6px 8px;\n                        background: #EEEEEE;\n                        border-top: 2px solid #fff;\n                        font-size: 11.5px;\n\n                        &:first-child {\n                            border-top-left-radius: 0.4rem;\n                            border-bottom-left-radius: 0.4rem;\n                        }\n\n                        &:last-child {\n                            border-top-right-radius: 0.4rem;\n                            border-bottom-right-radius: 0.4rem;\n                        }\n                    }\n                }\n            }\n\n            .indicator {\n                position: absolute;\n                top: 0;\n                left: 0px;\n                display: none;\n                font-size: 0.65rem;\n                color: #9097A2;\n\n                i {\n                    padding: 2px;\n                    background: #9097A2;\n                    border-radius: 0.2rem;\n                    color: #fff;\n                }\n            }\n\n            &:hover {\n                border: 1px solid #9097A2 !important;\n                border-radius: 0.4rem;\n\n                .indicator {\n                    display: block;\n                    transition: 1s all;\n                }\n            }\n        }\n    }\n\n    .question-theory {\n        .question-theory-block {\n            background: #FFC107;\n            box-shadow: 0px 3px 20px #00000029;\n        }\n\n        .title-block {\n            position: relative;\n\n            .title {\n                font: normal normal normal 15px/15px Proxima Nova;\n                letter-spacing: 0px;\n                color: #213046;\n                margin: 14px -30px;\n                transform: rotate(-90deg);\n                position: absolute;\n                width: 70px;\n                left: 0;\n                text-transform: capitalize;\n                opacity: 0.5;\n            }\n        }\n\n        .tables-block {\n            position: relative;\n            z-index: 1;\n        }\n\n        .list-one {\n            position: relative;\n\n            li {\n                position: absolute;\n\n                &:nth-child(1) {\n                    font-size: 4rem;\n                    color: #ffffff29;\n                    left: 28px;\n                    bottom: -10px;\n                }\n\n                &:nth-child(2) {\n                    font-size: 5rem;\n                    color: #ffffff29;\n                    left: 60px;\n                    bottom: -10px;\n                }\n\n                &:nth-child(3) {\n                    font-size: 2.5rem;\n                    color: #ffffff29;\n                    left: 8px;\n                    bottom: -19px;\n                }\n            }\n        }\n\n        .list-two {\n            position: relative;\n\n            li {\n                position: absolute;\n\n                &:nth-child(1) {\n                    font-size: 4rem;\n                    color: #ffffff29;\n                    right: 80px;\n                    bottom: -20px;\n                }\n\n                &:nth-child(2) {\n                    font-size: 5rem;\n                    color: #ffffff29;\n                    right: 30px;\n                    bottom: -10px;\n                }\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
